import DefaultTargetModal from './DefaultTargetModal';

export default DefaultTargetModal;
